import React from "react";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TablaMetroPasillo from "../components/TablaMetroPasillo";
import DialogAgregarEditarPasillo from "../components/DialogAgregarEditarPasillo";
import SnackbarAlert from "../components/SnackbarAlert";
import Grid from "@material-ui/core/Grid";
import SvgIcon from "@material-ui/core/SvgIcon";
import DialogExportar from "../components/DialogExportar";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import {Link} from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {pasillosResources} from "../endpoints";

class AuditoriaVisual extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            openDialog:false,
            openSnack:false,
            severity: null,
            message:null,
            open:false,
            metros: 0,
            pasillos: 0,
            metros_auditados: 0,
            showTabla: true,
            value: 'auditando',
            avance_para_auditar:0,
            avance_total:0,
            cumplimiento:0,
            cumplimiento_total:0
        }
    };

    refrescarDatos =(estado,severity) =>{
        this.setState({open:false,openDialog: false, openSnack:false, severity: null, message:null});

        this.setState({openSnack:true, severity:severity, message:estado}, ()=>{
            if(severity === "success"){
                this.setState({ showTabla: !this.state.showTabla})
                setTimeout(() => {
                    // After X seconds set the show value to false
                    this.setState({showTabla:!this.state.showTabla})
                }, 5)
            }
        })
    }

    obtenerAvance =()=>{
        pasillosResources.getAvanceAuditoria().then(async response => {
            if(response){
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                if (result.avance.metros_auditados !==0){
                    this.setState({metros_para_auditar: result.avance.metros_para_auditar, pasillos_para_auditar:result.avance.pasillos_para_auditar,
                        metros_auditados: result.avance.metros_auditados,
                        metros_totales: result.avance.metros_totales, pasillos_totales:result.avance.pasillos_totales,
                        metros_auditados_totales: result.avance.metros_auditados_totales,
                        avance_para_auditar: result.avance.metros_auditados/result.avance.metros_para_auditar * 100,
                        avance_total: result.avance.metros_auditados_totales/result.avance.metros_totales * 100,
                        cumplimiento: result.avance.metros_cumplen / result.avance.metros_auditados * 100,
                        cumplimiento_total: result.avance.metros_cumplen_totales / result.avance.metros_auditados_totales * 100,
                    });
                }
                else{
                    this.setState({metros_para_auditar: result.avance.metros_para_auditar, pasillos_para_auditar:result.avance.pasillos_para_auditar,
                        metros_auditados: result.avance.metros_auditados,
                        metros_totales: result.avance.metros_totales, pasillos_totales:result.avance.pasillos_totales,
                        metros_auditados_totales: result.avance.metros_auditados_totales,
                        avance_para_auditar: 0,
                        avance_total: 0,
                        cumplimiento: 0,
                        cumplimiento_total: 0,
                    });
                }
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.setState({
                openSnack: true,
                severity: 'error',
                message: "Ha ocurrido un error inesperado",
            })
        });
    };

    handleClose = () => {
        this.setState({openDialog: false, open:false});
    };

    handleChange = (event) => {
        this.setState({value: event.target.value});
    }

    enviarDatosReportes =(nombre)=>{
        let params = ""
        let reporte = nombre
        let origen  = "otro"

        this.setState({open: true, reporte: reporte, params: params,openSnack:false, origen:origen})
    }

    componentDidMount() {
        this.obtenerAvance()
    }

    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>
                    Auditoria visual
                </Typography>

                <Grid container direction="row" justifyContent={'center'} alignItems="center" spacing={3} style={{padding:10, marginBottom:10}}>
                    <Grid item>
                        <Card sx={{justifyContent: 'center',  minWidth: 700 }} style={{background:'#dbe9fc'}}>
                            <CardContent >
                                <Typography variant="h6">
                                    Auditando
                                </Typography>
                                <Grid item>
                                    <Typography variant="subtitle1" >
                                        <b>N° pasillos: </b>{this.state.pasillos_para_auditar}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" >
                                        <b>N° metros: </b>{this.state.metros_para_auditar}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" >
                                        <b>N° metros auditados: </b>{this.state.metros_auditados}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" >
                                        <b>Cumplimiento: </b>{(this.state.cumplimiento).toFixed(2)} %
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" >
                                        <b>Avance: </b>{(this.state.avance_para_auditar).toFixed(2)} %
                                    </Typography>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item>
                        <Card sx={{justifyContent: 'center', minWidth: 700}} style={{background:'#dbe9fc'}}>
                            <CardContent>
                                <Typography gutterBottom variant="h6" component="h2">
                                Total tienda
                                </Typography>
                                <Grid item>
                                    <Typography variant="subtitle1" >
                                        <b>N° pasillos: </b>{this.state.pasillos_totales}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" >
                                        <b>N° metros: </b>{this.state.metros_totales}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" >
                                        <b>N° metros auditados: </b>{this.state.metros_auditados_totales}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" >
                                        <b>Cumplimiento: </b>{(this.state.cumplimiento_total).toFixed(2)} %
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="subtitle1" >
                                        <b>Avance: </b>{(this.state.avance_total).toFixed(2)} %
                                    </Typography>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                <Grid container spacing={2} direction={"row"} justifyContent="flex-end" alignItems="flex-end">
                    <Grid item>
                        <RadioGroup style={{ display: 'inline-block'}} aria-label="gender" name="value" value={this.state.value} onChange={this.handleChange}>
                            <FormControlLabel value="todos" control={<Radio/>} label="Todos" />
                            <FormControlLabel value="auditando" control={<Radio/>} label="Auditando" />
                        </RadioGroup>
                    </Grid>

                    <Grid item>
                        <Button size="large" variant="contained" color="primary" onClick={() => this.setState({openDialog: true})}>
                            Agregar pasillo
                        </Button>
                    </Grid>
                    <Grid item>
                        <Link to={"/pasillos_para_auditar"} style={{color: '#000000', textDecoration: 'none'}}>
                            <Button size="large" variant="contained" color="primary">
                                Pasillos para auditoría
                            </Button>
                        </Link>
                    </Grid>
                    <Grid item>
                        <Button  size="large" startIcon={ <SvgIcon>
                            <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                        </SvgIcon>} variant="contained" name="auditoria_altillos" color="primary" onClick={() => this.enviarDatosReportes("resumen_auditoria_visual")}>
                            Exportar Resumen</Button>
                    </Grid>
                    <Grid item>
                        <Button  size="large" startIcon={ <SvgIcon>
                            <path fill="currentColor" d="M6,2C4.89,2 4,2.9 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35" />
                        </SvgIcon>} variant="contained" name="auditoria_altillos" color="primary" onClick={() => this.enviarDatosReportes("auditoria_visual")}>
                            Exportar Detalle</Button>

                    </Grid>
                </Grid>
                <br/>

                {this.state.openDialog? <DialogAgregarEditarPasillo accion={'agregar'} title={'Agregar pasillo'} padre={null} refrescar={this.refrescarDatos}  handleClose={this.handleClose}/> : null}
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.open? <DialogExportar reporte={this.state.reporte} origen={this.state.origen} params={this.state.params} refrescar={this.refrescarDatos} handleClose={this.handleClose}/> : null}
                {this.state.showTabla ? <TablaMetroPasillo tipo={this.state.value}></TablaMetroPasillo>:null}
            </div>
        )
    }
}

export default AuditoriaVisual;